import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AppResource } from 'src/app/app.resource';
import { Resource } from 'src/app/resources/resource';
import { getMaintenanceMessage } from '../../maintenance/maintenance-check';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class MaintenanceComponent {
  resource: Resource;
  // Message set from the back-office when the maintenance mode was enabled
  readonly message = getMaintenanceMessage();

  constructor(protected resources: AppResource) {
    this.resource = resources['resource'];
  }
}
